import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'prettifyHtml',
  standalone: false,
})
export class PrettifyHtmlPipe implements PipeTransform {
  private readonly voidTags = new Set(['area', 'base', 'br', 'col', 'embed', 'hr', 'img', 'input', 'link', 'meta', 'param', 'source', 'track', 'wbr']);

  transform(html: string): string {
    if (!html) return html;
    const tab = '  ';
    let indent = 0;
    let result = '';

    const normalized = html.replace(/>\s+</g, '><').trim();
    const tokens = normalized.match(/<[^>]+>|[^<]+/g) || [];

    for (const token of tokens) {
      const trimmed = token.trim();
      if (!trimmed) continue;

      if (/^<\//.test(trimmed)) {
        indent = Math.max(0, indent - 1);
        result += '\n' + tab.repeat(indent) + trimmed;
      } else if (/^</.test(trimmed)) {
        const tagName = (trimmed.match(/^<([a-zA-Z][a-zA-Z0-9-]*)/) || [])[1]?.toLowerCase();
        const isSelfClosing = trimmed.endsWith('/>') || (tagName && this.voidTags.has(tagName));
        result += '\n' + tab.repeat(indent) + trimmed;
        if (!isSelfClosing && tagName) indent++;
      } else {
        result += '\n' + tab.repeat(indent) + trimmed;
      }
    }

    return result.trim();
  }
}
